
export const achatsdemandeadd="commercial.achats.demande.add";
export const achatsdemandeedit="commercial.achats.demande.edit";
export const achatsdemandedelete="commercial.achats.demande.delete";

export const achatscommandeadd="commercial.achats.commande.add";
export const achatscommandeedit="commercial.achats.commande.edit";
export const achatscommandedelete="commercial.achats.commande.delete";

export const achatsreceptionadd="commercial.achats.reception.add";
export const achatsreceptionedit="commercial.achats.reception.edit";
export const achatsreceptiondelete="commercial.achats.reception.delete";

export const achatsretouradd="commercial.achats.retour.add";
export const achatsretouredit="commercial.achats.retour.edit";
export const achatsretourdelete="commercial.achats.retour.delete";

export const achatsfactureadd="commercial.achats.facture.add";
export const achatsfactureedit="commercial.achats.facture.edit";
export const achatsfacturedelete="commercial.achats.facture.delete";

export const achatsavoiradd="commercial.achats.avoir.add";
export const achatsavoiredit="commercial.achats.avoir.edit";
export const achatsavoirdelete="commercial.achats.avoir.delete";

export const achatsconsolidationfactureadd="commercial.achats.consolidationfacture.add";
export const achatsconsolidationfactureedit="commercial.achats.consolidationfacture.edit";
export const achatsconsolidationfacturedelete="commercial.achats.consolidationfacture.delete";

export const ventesdevisadd="commercial.ventes.devis.add";
export const ventesdevisedit="commercial.ventes.devis.edit";
export const ventesdevisdelete="commercial.ventes.devis.delete";

export const ventescommandeadd="commercial.ventes.commande.add";
export const ventescommandeedit="commercial.ventes.commande.edit";
export const ventescommandedelete="commercial.ventes.commande.delete";

export const ventespreparationadd="commercial.ventes.preparation.add";
export const ventespreparationedit="commercial.ventes.preparation.edit";
export const ventespreparationdelete="commercial.ventes.preparation.delete";

export const venteslivraisonadd="commercial.ventes.livraison.add";
export const venteslivraisonedit="commercial.ventes.livraison.edit";
export const venteslivraisondelete="commercial.ventes.livraison.delete";

export const ventesretouradd="commercial.ventes.retour.add";
export const ventesretouredit="commercial.ventes.retour.edit";
export const ventesretourdelete="commercial.ventes.retour.delete";

export const ventesfactureadd="commercial.ventes.facture.add";
export const ventesfactureedit="commercial.ventes.facture.edit";
export const ventesfacturedelete="commercial.ventes.facture.delete";

export const ventesavoiradd="commercial.ventes.avoir.add";
export const ventesavoiredit="commercial.ventes.avoir.edit";
export const ventesavoirdelete="commercial.ventes.avoir.delete";

export const ventesconsolidationfactureventeadd="commercial.ventes.consolidationfacturevente.add";
export const ventesconsolidationfactureventeedit="commercial.ventes.consolidationfacturevente.edit";
export const ventesconsolidationfactureventedelete="commercial.ventes.consolidationfacturevente.delete";

export const ventesavoirfinancieradd="commercial.ventes.avoirfinancier.add";
export const ventesavoirfinancieredit="commercial.ventes.avoirfinancier.edit";
export const ventesavoirfinancierdelete="commercial.ventes.avoirfinancier.delete";


export const achatsdemande="commercial.achats.demande";
export const achatscommande="commercial.achats.commande";
export const achatsreception="commercial.achats.reception";
export const achatsretour="commercial.achats.retour";
export const achatsfacture="commercial.achats.facture";
export const achatsavoir="commercial.achats.avoir";
export const ventesdevis="commercial.ventes.devis";
export const ventescommande="commercial.ventes.commande";
export const ventespreparation="commercial.ventes.preparation";
export const venteslivraison="commercial.ventes.livraison";
export const ventesretour="commercial.ventes.retour";
export const ventesfacture="commercial.ventes.facture";
export const ventesavoir="commercial.ventes.avoir";
export const ventesavoirfinancier="commercial.ventes.avoirfinancier";
export const stockproduits="stock.produits";
